import Chip from '@mui/material/Chip'
import Tooltip from '@mui/material/Tooltip'
import { Link as RouterLink } from 'react-router-dom'
import { useGetPublicationChangesQuery, useListPublicationsQuery } from '../../api/authoring'
import { routes } from '../../model/routes'

/** A compact latest-versus-release reading for a Website or one routed page. */
export function PublicationStatus({
  tenant,
  site,
  path,
  page = false,
}: {
  tenant: string
  site: string
  path?: string
  page?: boolean
}) {
  const releases = useListPublicationsQuery({ tenant, website: site })
  const changes = useGetPublicationChangesQuery(
    { tenant, website: site, path: page ? path : undefined },
    { skip: page && !path },
  )
  const to = routes.siteReleases(tenant, site)

  if (releases.error || changes.error) {
    return (
      <Tooltip title="Could not check whether this is live. Open Releases to try again.">
        <Chip component={RouterLink} to={to} clickable size="small" color="error" variant="outlined" label="Status unavailable" />
      </Tooltip>
    )
  }
  if (releases.isLoading || changes.isLoading || (page && !path)) {
    return <Chip size="small" variant="outlined" label="Checking…" />
  }
  if (!releases.data?.current) {
    return (
      <Tooltip title="Visitors cannot see this site yet. Open Releases to publish it.">
        <Chip component={RouterLink} to={to} clickable size="small" color="warning" label="Not published" />
      </Tooltip>
    )
  }
  if (changes.data?.changed) {
    const count = changes.data.changes.length
    return (
      <Tooltip title={`${count} change${count === 1 ? ' is' : 's are'} waiting to go live. Open Releases to publish.`}>
        <Chip component={RouterLink} to={to} clickable size="small" color="warning" label="Unpublished changes" />
      </Tooltip>
    )
  }
  return (
    <Tooltip title={`This ${page ? 'page' : 'site'} is live as of release ${releases.data.current}. Nothing has changed since.`}>
      <Chip component={RouterLink} to={to} clickable size="small" color="success" variant="outlined" label="Published" />
    </Tooltip>
  )
}
